import { TextFormFieldValidator } from './TextFormFieldValidator';

export class TextareaWithCounterFormFieldValidator extends TextFormFieldValidator {
  constructor(isRequired: boolean, minLength: Nullable<number>, maxLength: Nullable<number>) {
    super(isRequired, minLength, maxLength);
    if (this.maxLength === null) {
      throw new TypeError('Textarea with counter maxlength attribute is mandatory.');
    }
  }
}
